module.exports = __webpack_public_path__ + "static/media/YF89_3.b90a5a75.jpg";